import { AxiosError } from 'axios'
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  TextField,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import * as yup from 'yup'
import { Client } from 'src/api/models'
import { useForm } from 'src/forms'
import { setApiErrors } from 'src/forms/errors'
import { skuit } from 'src/services/skuit'
import { handleErrorMessage, Notification } from 'src/components/Notification'
import toast from 'react-hot-toast'

const useStyles = makeStyles(() => ({
  form: {
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
}))

interface ClientProps {
  name: string
  is_active: boolean
}

const clientSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
  is_active: yup.boolean().optional().label('Active'),
})

interface Props {
  open: boolean
  handleClose: () => void
  onSave?: () => void
  update?: boolean
  client?: Client
}

export const ClientDialog = (props: Props) => {
  const { open, handleClose, onSave, update, client } = props
  const classes = useStyles()

  const onSubmit = (data: ClientProps) => {
    let func = skuit.sc.clients.create
    let action = 'creat'
    if (update) {
      func = (data: ClientProps) => skuit.sc.clients.patch(client?.guid || '', data)
      action = 'updat'
    }
    func(data)
      .then((newClient: Client) => {
        handleClose()
        onSave?.()
        toast.success(() => (
          <Notification
            message={`Successfully ${action}ed Client: ${newClient.name}`}
            newObject={newClient}
          />
        ))
      })
      .catch((error: AxiosError) => {
        handleErrorMessage(error, action, 'Client')
        setApiErrors(formData.setError, error)
      })
  }

  const { Form, Field, data: formData } = useForm(clientSchema)

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <Form formProps={{ className: classes.form }} onSubmit={onSubmit}>
        <DialogTitle>{update ? 'Update' : 'Create'} Client</DialogTitle>
        <DialogContent>
          <Field
            name="name"
            defaultValue={client?.name}
            renderField={({ name, value, setValue, error }) => (
              <TextField
                id={name}
                name={name}
                label="Name"
                error={!!error}
                helperText={error}
                fullWidth
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setValue(name, e.target.value)
                }
                value={value || ''}
              />
            )}
          />
          <Field
            name="is_active"
            defaultValue={client?.isActive}
            renderField={({ name, value, setValue }) => (
              <FormControlLabel
                control={
                  <Checkbox
                    id={name}
                    name={name}
                    checked={value}
                    onChange={() => setValue(name, !value)}
                    value={value || ''}
                  />
                }
                label="Active"
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button type="submit" color="primary" variant="contained" autoFocus>
            Save
          </Button>
        </DialogActions>
      </Form>
    </Dialog>
  )
}
